<template>
    <div>
        <b-btn class="font-weight-bold" variant="danger" @click="modal = true">Undo Split</b-btn>
        <c-modal
                v-model="modal"
                cancel-label="Cancel, Never mind"
                centered size="md"
                title="Undo Split Confirmation"
                :tag="false"
                confirm-label="Undo Split"
                :progressing="loading"
                @submit="submit">
            <template>
                <div>
                    This action will merge back unpaid split tabs into one to undo the split (Paid split tabs will no be merged).Please confirm to proceed.
                </div>
            </template>
        </c-modal>
    </div>
</template>

<script>
    import CModal from "./Cmodal";
    export default {
        name: "undoSplit",
        props: {
            orderId: {required: true, type: [String, Number]}
        },
        components: {
            CModal
        },
        data () {
            return {
                modal: false,
                loading: false
            }
        },
        methods: {
            submit () {
                const model = {
                    OrderID: this.orderId,
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                }
                this.loading = true
                this.$api.getRestaurant.UndoSplitRestaurantOrders(model).then(res => {
                    this.loading = false
                    if (res.success) {
                        this.loading = false
                        this.modal = false
                        this.$emit('refresh')
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(err => {

                })
            }
        }
    }
</script>

<style scoped>

</style>
